import React, { useContext } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import Menus from './components/menus';
import {
  AppLayoutSidebarContainer,
  CustomerLogo,
  LogoAndToggleContainer,
  SidebarToggleButton,
} from './style';
import customerLogo from 'src/assets/logos/logo-manole-play.svg';
import SidebarContext from 'src/contexts/SidebarContext';

const AppLayoutSidebar: React.FC = () => {
  const { opened, setOpened } = useContext(SidebarContext);

  const toggleSidebar = () => {
    setOpened(!opened);
  };

  return (
    <AppLayoutSidebarContainer opened={opened}>
      <LogoAndToggleContainer>
        {opened && <CustomerLogo src={customerLogo} />}
        <SidebarToggleButton type="button" onClick={toggleSidebar}>
          <GiHamburgerMenu size={20} color="var(--black-60)" />
        </SidebarToggleButton>
      </LogoAndToggleContainer>

      <Menus />
    </AppLayoutSidebarContainer>
  );
};

export default AppLayoutSidebar;
